import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AgreementDialogueHandler } from './types';
import { useParams } from 'react-router-dom';
import AgreementContext from './AgreementContext';
import AccountContext from '../AccountContext';

const { ConfirmationDialogue } = vp;

type AgreementDialogueProps = {
  handleDialogue: DialogueHandler<AgreementDialogueHandler>;
};

type FC = FunctionComponent<AgreementDialogueProps>;

const AgreementDialogue: FC = ({ handleDialogue }: AgreementDialogueProps) => {
  const { showVoidAgreementConfirmAlert, showViewAgreementFailAlert } = useContext(AgreementContext);
  const { details } = useContext(AccountContext);
  const { accountId } = useParams<{ accountId: string }>();
  return useMemo(
    () => (
      <div>
        {/* Void Agreement */}
        <ConfirmationDialogue
          isVisible={showVoidAgreementConfirmAlert}
          title="Void Agreement"
          subTitle={`All agreement information will be deleted. Are you sure you wish to void ${details[accountId].accountName}’s agreement?`}
          status="alert"
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'void', state: 'back' }),
          }}
          cancel={{
            label: 'Confirm',
            action: () => handleDialogue({ type: 'void', state: 'confirm' }),
          }}
        />

        {
          /* View Agreement */
          <ConfirmationDialogue
            isVisible={showViewAgreementFailAlert}
            title="No Agreement Found"
            subTitle={`Cannot view agreement PDF as no agreement has been generated. Please add signors to start agreement generation process.`}
            status="alert"
            confirm={{
              label: 'Back',
              action: () => handleDialogue({ type: 'view', state: 'back' }),
            }}
            cancel={{
              label: 'Add Signers',
              action: () => handleDialogue({ type: 'view', state: 'confirm' }),
            }}
          />
        }
      </div>
    ),
    [showVoidAgreementConfirmAlert, showViewAgreementFailAlert],
  );
};

export default AgreementDialogue;
